import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Hero, CredentialBar, House, Origin, Operations, Standards, Responsibility, GlobalTrade, Inquiries } from "../components/sections";

export default function Home() {
  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero />
        <CredentialBar />
        <House />
        <Origin />
        <Operations />
        <Standards />
        <Responsibility />
        <GlobalTrade />
        <Inquiries />
      </main>
      <Footer />
    </div>
  );
}
